import { TextArea } from "@blueprintjs/core";
import { DailyInstantECharts } from "../charts/daily-instant";
import { useEffect, useState } from "react";
import { Icon } from "@blueprintjs/core";
import { PageHider } from "../components/PageHider";
import { WeeklyPage } from "../components/WeeklyPage";
import { ImageContainer } from "../components/ImageContainer";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const Page4 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
}: any) => {
  const [comments, setComments] = useState<any>(weekData?.page4?.comment ?? "");
  const [focusedImageId, setFocusedImageId] = useState<number>(1);

  const onTitleUpdated = (text: string) => {
    setComments(text);
    onPageDataUpdated("page4", "comment", text);
  };
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Genel Sentiment Değerlendirmesi");
  }, []);

  return (
    <WeeklyPage
      pageId={`page-${pageIndex}-${subIndex}`}
      onClick={() => {
        setFocusedImageId((prev) => prev + 1);
      }}
    >
      <WeeklyHeader title="HAFTALIK SENTİMENT DEĞERLENDİRMESİ" />

      <div
        style={{
          width: "100%",
          height: "100%",
          paddingInline: "10px",
          fontFamily: "Open Sans",
        }}
      >
        <div
          style={{
            backgroundColor: "#F7AF3D",
            padding: "5px 10px",
            fontWeight: "600",
            marginBottom: "10px",
            borderRadius: "2px",
            fontSize: "20px",
          }}
        >
          Genel Değerlendirme
        </div>
        <TextArea
          className="no-print"
          style={{ flex: 1, width: "100%", height: "80%" }}
          placeholder="Genel Sentiment Değerlendirmesini girebilirisiniz"
          onChange={(e) => onTitleUpdated(e.target.value)}
          defaultValue={comments}
        />
        <div
          className="print-only-block"
          style={{ color: "black", fontSize: 22, lineHeight: "33px" }}
        >
          <p>
            {comments
              ?.split("\n")
              .filter((item: string) => item.trim() !== "")
              .map((item: string) => (
                <p>{item}</p>
              ))}
          </p>
        </div>
      </div>
      <ImageContainer
        pageId={"page4"}
        onPageDataUpdated={onPageDataUpdated}
        weekData={weekData?.page4}
        focusedImageId={focusedImageId}
      />
    </WeeklyPage>
  );
};
